import type { ComponentProps } from "react";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { RepliesView } from "@/components/admin/prospection/replies-view";
import { useAdminView } from "@shared/client/admin-view";
import { usePageTitle } from "@shared/client/view";

export default function ProspectionRepliesPage() {
  usePageTitle("Réponses — Prospection — Administration Hune");
  const { data, error } = useAdminView<ComponentProps<typeof RepliesView>>("/api/views/admin/prospection/replies");
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <RepliesView {...data} />;
}
